import React from "react";
import { useTranslation } from "react-i18next";

export default function CookiePage() {
    const { t } = useTranslation();
    const sections = t("cookie_policy.sections", { returnObjects: true });

    const openPreferences = () =>
        window.dispatchEvent(
            new CustomEvent("auronixra:open-cookie-preferences"),
        );

    return (
        <section className="aurx-legal" data-testid="cookie-page">
            <div className="aurx-container aurx-legal-body">
                <span className="aurx-updated">
                    {t("cookie_policy.updated")}
                </span>
                <h1
                    className="aurx-h2"
                    style={{ marginTop: 12, marginBottom: 20 }}
                >
                    {t("cookie_policy.title")}
                </h1>
                <p className="p-lead">{t("cookie_policy.intro")}</p>
                {Object.keys(sections).map((k) => (
                    <div key={k}>
                        <h2>{sections[k].title}</h2>
                        <p>{sections[k].body}</p>
                    </div>
                ))}
                <button
                    onClick={openPreferences}
                    className="aurx-btn aurx-btn-primary"
                    style={{ marginTop: 24 }}
                    data-testid="cookie-page-manage"
                >
                    {t("cta.manage_cookies")}
                </button>
            </div>
        </section>
    );
}
